
import type { GameSession } from './session.types'
import type { Tariff } from './tariff.types'

export const TableStatus = {
    IDLE: 'IDLE',
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    MAINTENANCE: 'MAINTENANCE',
    OFFLINE: 'OFFLINE',
    ERROR: 'ERROR',
    BOOKED: 'BOOKED'
} as const

export type TableStatus = typeof TableStatus[keyof typeof TableStatus]

export const TableType = {
    POOL: 'POOL',
    PYRAMID: 'PYRAMID',
    SNOOKER: 'SNOOKER',
    VIP: 'VIP'
} as const

export type TableType = typeof TableType[keyof typeof TableType]

export interface PoolTable {
    id: number
    name: string
    type: TableType
    status: TableStatus
    lastHeartbeat: string | null
    missedHeartbeats: number
    sessionSelectedTariffId?: number | null
    currentTariff?: Tariff
    activeSession?: GameSession
    /** True when table has a linked camera and video billing controls apply. */
    hasCamera?: boolean
}

// Request DTOs
export interface StartTableRequest {
    durationMinutes: number
    players: Array<{
        userId?: number
        guestName?: string
    }>
    tariffId?: number | null
    pauseAfterDuration?: boolean
    videoRecordingEnabled?: boolean
}

export interface StopTableRequest {
    payerAssignmentIds?: number[]
    lateVideoRecording?: boolean
}

export interface AddPlayerRequest {
    userId?: number
    guestName?: string
}

export interface FinishSetRequest {
    payerAssignmentIds: number[]
}